/* Pure Desi · My Diwali list — pure logic (2 Oct 2026). No DOM, no network.
   Loaded before pd-list.js as window.PDListCore; unit-tested in ~/Developer/pure-desi-diwali-list/test/core.test.js. */
(function (root, factory) {
  var api = factory();
  if (root) root.PDListCore = api; // always, so the browser and the test sandbox both see it
  if (typeof module === "object" && module && module.exports) module.exports = api;
})(typeof self !== "undefined" ? self : this, function () {
  "use strict";
  var LIMITS = { lines: 60, name: 40, notes: 1000, qty: 20 };
  var CLOSE_AT = Date.UTC(2026, 9, 29, 12, 59); // Thu 29 Oct 2026 11:59pm Sydney (AEDT)
  var STAMP = { _order_type: "diwali-preorder" };
  var WEEK = 7 * 24 * 3600 * 1000;
  // The planner's two opening questions and the boxes they lead to, copied from the live gift planner (2 Oct 2026).
  var HOMES = ["1", "2-4", "5-9", "10+"];
  var TASTES = ["kaju", "ladoo", "burfi", "syrup", "mix"];
  var PICKS = { // taste -> size -> product handle (L = large, S = small, XS = extra small)
    kaju: { L: "diwali-special-large-kaju-box", S: "diwali-special-small-kaju-box", XS: "extra-small-mix-box-1" },
    ladoo: { L: "diwali-special-boondi-ladoo-box", S: "diwali-special-small-motichoor-box", XS: "extra-small-motichoor-ladoo-box-diwali-special" },
    burfi: { L: "diwali-special-large-mix-burfi-box-1", S: "small-mix-burfi-diwali-special-box", XS: "extra-small-best-seller-diwali-box" },
    syrup: { L: "diwali-special-large-staff-selection-box", S: "small-syrup-soaker-diwali-box", XS: "extra-small-best-seller-diwali-box" },
    mix: { L: "diwali-special-classic-box", S: "diwali-special-small-kaju-box", XS: "extra-small-best-seller-diwali-box" }
  };
  var STARTER = { // homes -> how many boxes of each size
    "1": { L: 1, S: 0, XS: 0 },
    "2-4": { L: 1, S: 2, XS: 0 },
    "5-9": { L: 2, S: 2, XS: 2 },
    "10+": { L: 4, S: 4, XS: 5 }
  };
  var DOMAINS = ["gmail.com", "yahoo.com", "yahoo.com.au", "ymail.com", "hotmail.com", "hotmail.com.au", "outlook.com",
    "outlook.com.au", "live.com", "live.com.au", "icloud.com", "me.com", "mail.com", "aol.com", "bigpond.com",
    "bigpond.net.au", "optusnet.com.au", "protonmail.com", "proton.me", "msn.com", "mac.com", "gmx.com", "gmx.net", "aim.com",
    "y7mail.com", "email.com"];

  function isClosed(now) { return now > CLOSE_AT; }
  function isValidId(id) { return typeof id === "string" && /^[A-Za-z0-9_-]{22}$/.test(id); }
  function emptyList() { return { id: null, lines: [{ name: "", variant_id: "", qty: 1 }], notes: "", emailed: false, updated_at: 0 }; }
  function validEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(e || "").trim()); }

  function lev(a, b) {
    var m = a.length, n = b.length, d = [], i, j;
    for (i = 0; i <= m; i++) { d[i] = [i]; }
    for (j = 0; j <= n; j++) { d[0][j] = j; }
    for (i = 1; i <= m; i++) for (j = 1; j <= n; j++)
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    return d[m][n];
  }
  function suggestEmail(e) {
    var s = String(e || "").trim().toLowerCase(), at = s.lastIndexOf("@");
    if (at < 1) return null;
    var dom = s.slice(at + 1);
    if (DOMAINS.indexOf(dom) >= 0) return null;
    var maxDist = dom.length <= 8 ? 1 : 2;
    var best = null, bestD = maxDist + 1;
    for (var k = 0; k < DOMAINS.length; k++) { var dd = lev(dom, DOMAINS[k]); if (dd < bestD) { bestD = dd; best = DOMAINS[k]; } }
    return (best && bestD <= maxDist) ? s.slice(0, at + 1) + best : null;
  }

  // Short display title for a box: "Royal Kaju Diwali Box - Window" -> "Royal Kaju · Window".
  function boxTitle(raw) {
    var t = String(raw || "").replace(/^\s*Diwali Special\s+/i, "").replace(/\s*Diwali Box\s*/gi, " ")
      .replace(/\s+[-\u2013]\s+/g, " \u00B7 ").replace(/\s+/g, " ").trim();
    return t || String(raw || "").trim();
  }
  function parseCatalog(json) {
    var out = [];
    ((json && json.products) || []).forEach(function (p) {
      if (p.product_type !== "Diwali Gift Box") return;
      var v = p.variants && p.variants[0];
      if (!v) return;
      out.push({ variant_id: String(v.id), title: boxTitle(p.title), handle: p.handle, price: Math.round(parseFloat(v.price) * 100), available: !!v.available });
    });
    out.sort(function (a, b) { return b.price - a.price || (a.title < b.title ? -1 : 1); });
    return out;
  }
  function indexCatalog(cat) { var idx = {}; (cat || []).forEach(function (c) { idx[c.variant_id] = c; }); return idx; }
  function qtyOf(l) { return Math.max(0, Math.min(LIMITS.qty, parseInt(l.qty, 10) || 0)); }

  function summarize(lines, cat) {
    var idx = indexCatalog(cat), names = {}, boxes = 0, cents = 0;
    (lines || []).forEach(function (l) {
      var trimmedName = String(l.name || "").trim();
      if (trimmedName) names[trimmedName.toLowerCase()] = 1;
      var c = l.variant_id ? idx[String(l.variant_id)] : null;
      var qty = qtyOf(l);
      if (c && c.available) { boxes += qty; cents += c.price * qty; }
    });
    return { homes: Object.keys(names).length, boxes: boxes, cents: cents };
  }
  function plural(n, one, many) { return n + " " + (n === 1 ? one : many); }
  function metaLine(s) {
    var parts = [];
    if (s.homes) parts.push(plural(s.homes, "home", "homes"));
    parts.push(plural(s.boxes, "box", "boxes"));
    parts.push("orders close Thu 29 Oct");
    return parts.join(" · ");
  }
  function money(cents) {
    var parts = (cents / 100).toFixed(2).split(".");
    return "$" + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + parts[1];
  }

  function addPlan(lines, cat, cartItems) {
    var idx = indexCatalog(cat), want = {}, order = [], skipped = [], have = {}, items = [];
    (lines || []).forEach(function (l) {
      if (!l.variant_id) return;
      var vid = String(l.variant_id), c = idx[vid];
      if (!c || !c.available) { skipped.push(l); return; }
      if (!(vid in want)) { want[vid] = 0; order.push(vid); }
      want[vid] += qtyOf(l);
    });
    (cartItems || []).forEach(function (it) { var k = String(it.variant_id || it.id); have[k] = (have[k] || 0) + it.quantity; });
    order.forEach(function (vid) {
      var add = want[vid] - (have[vid] || 0);
      if (add > 0) items.push({ id: Number(vid), quantity: add, properties: { _order_type: STAMP._order_type } });
    });
    return { items: items, skipped: skipped };
  }

  function own(o, k) { return typeof k === "string" && Object.prototype.hasOwnProperty.call(o, k); }
  // The first list for a new shopper: one line per home (large boxes first, then small, then extra small), no names yet.
  // A pick that is missing from the catalogue or sold out leaves its box blank for the shopper to choose. Unknown answers give [].
  function starterLines(homes, taste, cat) {
    if (!own(STARTER, homes) || !own(PICKS, taste)) return [];
    var byHandle = {}, plan = STARTER[homes], picks = PICKS[taste], out = [];
    (cat || []).forEach(function (c) { if (c && c.handle) byHandle[c.handle] = c; });
    ["L", "S", "XS"].forEach(function (size) {
      var c = own(byHandle, picks[size]) ? byHandle[picks[size]] : null;
      for (var n = 0; n < plan[size]; n++) out.push({ name: "", variant_id: c && c.available ? String(c.variant_id) : "", qty: 1 });
    });
    return out;
  }

  // "Add to my list" from a card or a product page (2 Oct 2026): the box goes on the first blank line (no name, no box), or on a new line
  // at the end. A named line or a line that already has a box is never overwritten. Returns a copy; the input is not changed.
  function addBoxLine(lines, variantId) {
    var vid = String(variantId == null ? "" : variantId), out = (lines || []).map(function (l) { return { name: l.name, variant_id: l.variant_id, qty: l.qty }; });
    if (!/^\d+$/.test(vid)) return { added: false, index: -1, lines: out };
    for (var i = 0; i < out.length; i++) {
      if (!String(out[i].name || "").trim() && !out[i].variant_id) { out[i] = { name: out[i].name || "", variant_id: vid, qty: 1 }; return { added: true, index: i, lines: out }; }
    }
    if (out.length >= LIMITS.lines) return { added: false, index: -1, lines: out };
    out.push({ name: "", variant_id: vid, qty: 1 });
    return { added: true, index: out.length - 1, lines: out };
  }
  // Boxes on the list, for a count badge: the quantity of every line that has a box. Needs no catalogue, so sold-out boxes count too.
  function boxCount(lines) { return (lines || []).reduce(function (t, l) { return t + (l && l.variant_id ? qtyOf(l) : 0); }, 0); }

  // ctx = { now, pageViews, hasDetails, dismissedAt, shownThisSession, path, drawerOpen, sheetOpen }
  var NO_POPUP = ["/cart", "/pages/diwali-pre-order-policy", "/pages/my-diwali-list"], NO_POPUP_PREFIX = ["/cart/", "/checkout", "/checkouts", "/account"]; // "/cart/" = cart permalinks (/cart/c/...); /cartoon is fine
  function shouldAutoOpen(ctx) {
    if (!ctx) return false;
    if (isClosed(ctx.now)) return false;
    if (!(ctx.pageViews >= 2)) return false;
    if (ctx.hasDetails || ctx.shownThisSession || ctx.drawerOpen || ctx.sheetOpen) return false;
    if (ctx.dismissedAt && !(ctx.now - ctx.dismissedAt >= WEEK)) return false;
    var p = String(ctx.path || "").toLowerCase().replace(/\/+$/, "");
    if (NO_POPUP.indexOf(p) >= 0) return false;
    for (var i = 0; i < NO_POPUP_PREFIX.length; i++) if (p.indexOf(NO_POPUP_PREFIX[i]) === 0) return false;
    return true;
  }

  function toPayload(list) {
    return {
      lines: (list.lines || []).filter(function (l) { return String(l.name || "").trim() || l.variant_id; })
        .map(function (l) { return { name: String(l.name || "").trim(), variant_id: l.variant_id || "", qty: qtyOf(l) }; }),
      notes: list.notes || ""
    };
  }

  function eventProps(list, cat, kind, url) {
    var idx = indexCatalog(cat), s = summarize(list.lines, cat), lines = [];
    (list.lines || []).forEach(function (l) {
      var trimmedName = String(l.name || "").trim();
      if (!trimmedName && !l.variant_id) return;
      var c = l.variant_id ? idx[String(l.variant_id)] : null;
      lines.push({
        name: trimmedName,
        box: c ? c.title : (l.variant_id ? "A box no longer available" : "Box not chosen yet"),
        qty: l.variant_id ? qtyOf(l) : 0,
        sold_out: !!(l.variant_id && (!c || !c.available))
      });
    });
    return { kind: kind, list_id: list.id, list_url: url, lines: lines, line_count: lines.length, box_count: s.boxes, homes: s.homes, total: money(s.cents), notes: list.notes || "" };
  }

  return { LIMITS: LIMITS, CLOSE_AT: CLOSE_AT, HOMES: HOMES, TASTES: TASTES, PICKS: PICKS, STARTER: STARTER, isClosed: isClosed, isValidId: isValidId, emptyList: emptyList, validEmail: validEmail,
    suggestEmail: suggestEmail, parseCatalog: parseCatalog, indexCatalog: indexCatalog, summarize: summarize, metaLine: metaLine,
    money: money, addPlan: addPlan, toPayload: toPayload, eventProps: eventProps, starterLines: starterLines, shouldAutoOpen: shouldAutoOpen, addBoxLine: addBoxLine, boxCount: boxCount };
});
